import dayjs from "dayjs";
import { apiGet } from "./utils";
import { GetDriverDetailsCrew } from "./apiUrls";

/**
 * Android / external boarding URL.
 * Example:
 * /passenger-boarding?ptfrm=android&tkn=&intTripID=191557&dtJDate=2026-10-19&intCompanyID=1
 *
 * Driver ID comes from GetDriverDetailsCrew(intTripID, dtCDate), not from the URL.
 */
export function parseBoardingContextFromUrlParams(searchParams) {
  const params = searchParams?.toString?.()
    ? searchParams
    : new URLSearchParams(window.location.search);
  const tripId = params.get("intTripID") ?? params.get("TripID");
  const journeyDate = params.get("dtJDate") ?? params.get("JourneyDate");
  const chartDate = params.get("chartDate") ?? params.get("dtCDate");
  const companyId =
    params.get("intCompanyID") ??
    params.get("CompanyId") ??
    params.get("iCompanyid");

  const missing = [];
  if (!tripId) missing.push("intTripID");
  if (!journeyDate) missing.push("dtJDate");
  if (!chartDate) missing.push("chartDate");
  if (!companyId) missing.push("intCompanyID");

  if (missing.length) {
    return { isValid: false, missing };
  }

  return { isValid: true, tripId, journeyDate, chartDate, companyId };
}

function extractDriverIdFromCrewResponse(res) {
  let data = res?.Data;
  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch {
      return null;
    }
  }

  const row = Array.isArray(data)
    ? data[0]
    : Array.isArray(data?.Table)
      ? data.Table[0]
      : data;

  return (
    row?.DriverID ??
    row?.intDriverID ??
    row?.DriverId ??
    row?.UserID ??
    row?.intUserId ??
    row?.intUserID ??
    null
  );
}

const driverIdPromises = new Map();

export function getDriverIdForUrlBoarding(tripId, chartDate) {
  const key = `${tripId}|${dayjs(chartDate).format("YYYY-MM-DD")}`;
  if (!driverIdPromises.has(key)) {
    driverIdPromises.set(
      key,
      apiGet(GetDriverDetailsCrew, {
        intTripID: tripId,
        dtCDate: dayjs(chartDate).format("YYYY-MM-DD"),
      }).then((res) => {
        if (!res?.IsSuccess && !res?.status) {
          throw new Error(res?.ErrorMessage || res?.Message || "Error fetching driver details");
        }
        const driverId = extractDriverIdFromCrewResponse(res);
        if (!driverId) {
          throw new Error("Driver ID not found for this trip");
        }
        return driverId;
      }).catch((err) => {
        driverIdPromises.delete(key);
        throw err;
      })
    );
  }
  return driverIdPromises.get(key);
}
